import { useMutation } from '@tanstack/react-query';
import { removeDashboard } from '@src/api/dashboards';

function useDeleteSavedDashboard() {
  const deleteSDMutation = useMutation(removeDashboard);

  return { deleteSDMutation };
}

export default useDeleteSavedDashboard;